import React, { useEffect, useCallback, useState} from 'react';
import {setLinkingEffects} from 'actions/index.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {connect} from 'react-redux';

const LinkedTidalComponent = ({
    setLinkingEffects,
    sequencerEngine,
    effect,
    effectNumber,
    linkingEffects
}) => { 
    const map = useCallback((e) => {
        if (linkingEffects) {
            setLinkingEffects(undefined);
        } else {
            setLinkingEffects(effect, "Tidal");
        }
    }, [linkingEffects, effect]);
    return (
        <div>
          <div
            onClick={map}
            className={linkingEffects ? "map-button mapping" : "map-button"}>
            {effect.linkedEffect ? "Unmap Linked Tidal" : "Map Tidal Effect"}
          </div>
          <EffectParameterSlider
            effectNumber={effectNumber}
            name={'Cycle Factor'}
            parameter={effect.cycleFactorParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            step={0.25}
            min={0.25}
            max={16}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      linkingEffects: state.effects.linkingEffects
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setLinkingEffects: (a,b) => dispatch(setLinkingEffects(a,b))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedTidalComponent);
